// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__14DoX","choiceBoxes":"toolbarselects_choiceBoxes__PaPc4","simpleField":"toolbarselects_simpleField__2PWA-"};